import * as React from "react";
import { ContentProps } from "components/flexComponents/Content/typings";
import { inject } from "mobx-react";
import { ContentFactory } from "components/flexComponents/Content/factory/ContentFactory";

export const Content: React.FC<ContentProps> = inject(
  "routeStore",
  "analytics"
)(props => {
  const flexComponent = props.flexComponent;

  const contentComponent = ContentFactory.get(flexComponent);

  if (!contentComponent.shouldRender()) {
    return null;
  }

  return contentComponent.generate(props);
});

export default Content;
